import React, { useState, useEffect } from "react";
import "./floating-filter-style.css";

const DropdownFloatingFilter = (props: any) => {
  const {
    options = [],
    placeholder = "Select...",
    resetKey,
    onValueChange
  } = props;

  const [selectedValue, setSelectedValue] = useState<string>("");


  useEffect(() => {
    if (resetKey !== undefined) {
      
      setSelectedValue("");
    }
  }, [resetKey]);

  
    useEffect(() => {
      if (!props.parentFilterInstance) return;
    
      props.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(
          selectedValue ? "equals" : null,
          selectedValue || null
        );
      });
    
     
      if (onValueChange) {
        onValueChange(selectedValue || null);
      }
    }, [selectedValue]);
    
  return (
    <div className="floating-filter-container">
      <select
        value={selectedValue}
        onChange={(e) => setSelectedValue(e.target.value)}
        className="floating-filter-input"
      >
        <option value="">{placeholder}</option>
        {options.map((opt: string, index: number) => (
          <option key={index} value={opt}>
            {opt}
          </option>
        ))}
      </select>
     

    </div>
  );
};

export default DropdownFloatingFilter;


